import { Dayjs } from "dayjs"
import {
  SoDataTableCompareFunction,
  SoDataTableCustomComponent,
  SoDataTableDatePeriod,
} from "@/types/components/SoDataTable"
import { SoChipType } from "@/types/components/SoChip"
import { AccountPassRate } from "@/models/admin/testAccountHealth/passRate"

export const dateSorter: SoDataTableCompareFunction = (
  a: Dayjs | null | undefined,
  b: Dayjs | null | undefined,
) => {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1
  return a.isBefore(b) ? -1 : 1
}
export const datePeriodSorter: SoDataTableCompareFunction = (
  a: SoDataTableDatePeriod | null | undefined,
  b: SoDataTableDatePeriod | null | undefined,
) => {
  return dateSorter(a?.datePeriod?.from, b?.datePeriod?.from)
}

export const statusesSorter: SoDataTableCompareFunction = (
  statusesA: SoDataTableCustomComponent[],
  statusesB: SoDataTableCustomComponent[],
) => {
  const statusesAStr = statusesA.reduce(
    (text: string, chip: SoDataTableCustomComponent) => `${text} ${chip.value}`,
    "",
  )
  const statusesBStr = statusesB.reduce(
    (text: string, chip: SoDataTableCustomComponent) => `${text} ${chip.value}`,
    "",
  )

  if (statusesAStr < statusesBStr) return -1
  if (statusesAStr > statusesBStr) return 1
  return 0
}

export const chipSorter: SoDataTableCompareFunction = (chipA, chipB) => {
  const chipOrder = Object.values(SoChipType)
  const chipAStr = chipOrder.indexOf(chipA.props.type) + chipA.value
  const chipBStr = chipOrder.indexOf(chipB.props.type) + chipB.value
  if (chipAStr < chipBStr) return -1
  if (chipAStr > chipBStr) return 1
  return 0
}

export const statusSorter: SoDataTableCompareFunction = (statusA, statusB) => {
  const statusOrder = ["critical", "caution", "normal", "default"]
  const statusAStr = statusOrder.indexOf(statusA.props.type) + statusA.value
  const statusBStr = statusOrder.indexOf(statusB.props.type) + statusB.value
  if (statusAStr < statusBStr) return -1
  if (statusAStr > statusBStr) return 1
  return 0
}

export const moneySorter: SoDataTableCompareFunction = (
  a: string | number | null | undefined,
  b: string | number | null | undefined,
) => {
  const aNum = Number(a)
  const bNum = Number(b)
  const aInvalid = a === null || isNaN(aNum)
  const bInvalid = b === null || isNaN(bNum)
  if (aInvalid && bInvalid) return 0
  if (aInvalid) return -1
  if (bInvalid) return 1
  if (aNum < bNum) return -1
  if (aNum > bNum) return 1
  return 0
}

export const passRateSorter: SoDataTableCompareFunction = (
  a: AccountPassRate | null | undefined,
  b: AccountPassRate | null | undefined,
) => {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  if (a.pct < b.pct) return -1
  if (a.pct > b.pct) return 1
  return 0
}
